import React from "react";
import ReactDOM from "react-dom";
import Countdown from "react-countdown";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Tel from "../../img/telegram.png";

import Uni from "../../img/uniswap.png";

import Del from "../../img/dextool.png";

import Eth from "../../img/etherscan.png";

import logoimg from "../../img/logo.png";
import "./styles.css";
// Random component
const Completionist = () => {
  return (
    <div className="col-12">
      <p className="mt-5 pcc---timeoutclass">You can claim your rewards now </p>
      {/* <div>
                <a href="https://t.me/pCatCore" style={{padding: "0px 7px"}} target="_blank" ><img src={Tel} style={{width: "52px"}} /></a>
                <a href="https://www.dextools.io/app/uniswap/pair-explorer/0xb7a48277ac6517f3f19e3b4c380b1eb5c7b01a07" style={{padding: "0px 7px"}} target="_blank" ><img src={Del} style={{width: "52px"}} /></a>
                <a href="https://etherscan.io/address/0x5b1ca4d29d0071936aa59bd08524d868e36a99b7" style={{padding: "0px 7px"}} target="_blank" ><img src={Eth} style={{width: "52px"}} /></a>
                <a href="https://app.uniswap.org/#/swap?inputCurrency=0x5b1ca4d29d0071936aa59bd08524d868e36a99b7" style={{padding: "0px 7px"}} target="_blank" ><img src={Uni} style={{width: "52px"}} /></a>
      </div> */}
      <br />
      {/* <a
        href="https://www.dextools.io/app/uniswap/pair-explorer/0x8e7a50a2cf68f866514ff33011c7933aba9e47e9"
        style={{ textDecoration: "underline", marginTop: 14, display: "block" }}
      >
        Click here to visit
      </a> */}
    </div>
  );
};
// Renderer callback with condition

const renderer = ({ days,hours, minutes, seconds, completed }) => {
  if (completed) {
    // Render a complete state
    return <Completionist />;
  } else {
    // alert(Date.now());

    // Render a countdown
    return (
      <Container>
        <Grid
          container
          justify="center"
          direction="row"
          xs={11}
          sm={11}
          md={8}
          lg={6}
          xl={6}
          spacing={3}
          className="mx-auto pcc---timespan py-4 my-2"
          style={{margin: '0'}}
        >

<Grid
            container
            justify="center"
            direction="row"
            xs={3}
            className="mx-auto pcc---timespan"
          >
            <h5 className="mb-2 Font--size" style={{color:'black'}}>Days</h5>
            <div className="pcc---countdown_div">
              <h1>
                {days}
                <br />
                
              </h1>
            </div>
          </Grid>
          <Grid
            container
            justify="center"
            direction="row"
            xs={3}
            className="mx-auto pcc---timespan"
          >
            <h5 className="mb-2 Font--size" style={{color:'black'}}>Hours</h5>
            <div className="pcc---countdown_div">
              <h1>
                {hours}
                <br />
                
              </h1>
            </div>
          </Grid>
          <Grid
            container
            justify="center"
            direction="row"
            xs={3}
            className="mx-auto  pcc---timespan"
          >
             <h5 className="mb-2 Font--size" style={{color:'black'}}>Minutes</h5>
            <div className="pcc---countdown_div">
              <h1>
                {minutes}
                <br />
               
              </h1>
            </div>
          </Grid>
          <Grid
            container
            justify="center"
            direction="row"
            xs={3}
            className="mx-auto pcc---timespan"
          >
             <h5 className="Font--size mb-2" style={{color:'black'}} >Seconds</h5>
            <div className="pcc---countdown_div">
              <h1>
                {seconds}
                <br />
               
              </h1>
            </div>
          </Grid>
        </Grid>
      </Container>
    );
  }
};

const App = () => {
  // return <Countdown date={Date.now() + 11} renderer={renderer} />
  return <Countdown date="2022-02-19T01:02:03" renderer={renderer} />;
};

export default App;
